/**
 * Date formatting utilities for user management.
 */

/**
 * Formats a date string for display in user tables.
 * Returns "—" for null/undefined/empty values.
 */
export function formatUserDate(dateString: string | null | undefined): string {
  if (!dateString) {
    return '—';
  }
  // API returns ISO format (e.g., "2026-01-15T10:30:00Z"), extract date part
  return dateString.slice(0, 10);
}
